
/* eslint-disable */
// disable because of thse warnings:
// Line 153:32:  eval can be harmful               no-eval
//   Line 157:31:  eval can be harmful               no-eval
//   Line 170:34:  Unnecessary escape character: \d  no-useless-escape 
//   Line 170:37:  Unnecessary escape character: \.  no-useless-escape 
//   Line 170:40:  Unnecessary escape character: \d  no-useless-escape 

import { useTheme } from '@mui/material';
import { InputMask } from '@react-input/mask';
import { CustomCellEditorProps, useGridCellEditor } from "ag-grid-react";
import React, { useCallback, useEffect, useRef, useState } from 'react';

const KEY_BACKSPACE = 'Backspace';
const KEY_DELETE = 'Delete';
const KEY_ENTER = 'Enter';
const KEY_TAB = 'Tab';

export type ITimeCellEditorProps = {
} & CustomCellEditorProps;

// type TimeCellEditorState = {
//     value: string,
//     highlightAllOnFocus: boolean;
// };

export function TimeCellEditor({
    value,
    eGridCell,
    eventKey,
    data,
    onValueChange
}: ITimeCellEditorProps) {

    //export const TimeCellEditor = forwardRef((props: ITimeCellEditorProps, ref) => {

    const theme = useTheme();

    // const createInitialState = (): TimeCellEditorState => {

    //     let startValue;
    //     let highlightAllOnFocus = true;

    //     if (eventKey === KEY_BACKSPACE || eventKey === KEY_DELETE) {
    //         // if backspace or delete pressed, we clear the cell
    //         startValue = '';
    //     } else if (eventKey && eventKey.match(/[a-z]/i)) {
    //         // if a letter was pressed, we start with the letter
    //         startValue = eventKey;
    //         highlightAllOnFocus = false;
    //     } else {
    //         // otherwise we start with the current value
    //          startValue = value;
    //     }

    //     return {
    //         value: startValue,
    //         highlightAllOnFocus
    //     };
    // };

    // const initialState = createInitialState();
    // const [value, setValue] = useState(initialState.value);
    // const [highlightAllOnFocus, setHighlightAllOnFocus] = useState(initialState.highlightAllOnFocus);
    const [highlightAllOnFocus, setHighlightAllOnFocus] = useState(true);
    const refInput = useRef<HTMLInputElement>(null);

    // Takes the place of the old afterGuiAttached
    useEffect(() => {
        eGridCell.style.borderColor = '';
        data.valid = true;

        // setValue(props.value);
        if (refInput.current) {
            refInput?.current.focus();
            refInput?.current.select();
        }
    }, []);

    // focus on the input
    useEffect(() => {

        // get ref from React component
        const eInput = refInput.current;
        eInput?.focus();
        if (highlightAllOnFocus) {
            eInput?.select();

            setHighlightAllOnFocus(false);
        }
    }, [
        highlightAllOnFocus,
        setHighlightAllOnFocus,
        refInput
    ]);

    const cancelBeforeStart = !!eventKey && ('1234567890'.indexOf(eventKey) < 0);

    const isLeftOrRight = (event: React.KeyboardEvent<HTMLInputElement>) => {
        return ['ArrowLeft', 'ArrowRight'].indexOf(event.key) > -1;
    };

    const getCharCodeFromEvent = (event: React.KeyboardEvent<HTMLInputElement>) => {
        event = event || window.event;
        return event.key;
    };

    const isCharNumeric = (char: string) => {
        return !!/\d/.test(char);
    };

    const isKeyPressedNumeric = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const charStr = event.key;
        return isCharNumeric(charStr);
    };

    const deleteOrBackspace = (event: React.KeyboardEvent<HTMLInputElement>) => {
        return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.key) > -1;
    };

    const finishedEditingPressed = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const charCode = getCharCodeFromEvent(event);
        return charCode === KEY_ENTER || charCode === KEY_TAB;
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (isLeftOrRight(event) || deleteOrBackspace(event)) {
            event.stopPropagation();
            return;
        }

        if (!finishedEditingPressed(event) && !isKeyPressedNumeric(event)) {
            if (event.preventDefault) {
                event.preventDefault();
            }
        }
    };

    const onChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        // const value = +event.target.value;
        // setValue(event.target.value);
        onValueChange(event.target.value);
        data.valid = true;
        eGridCell.style.borderColor = '';
    };

    /* ag-grid component Editor Lifecycle methods */
    // useImperativeHandle(ref, () => {
    //     return {
    //         // the final value to send to the grid, on completion of editing
    //         getValue() {
    //             let v = `${value}`;
    //             if (v.endsWith('.')) {
    //                 return v.replace('.', '');
    //             }
    //             return v;
    //         },
    //         afterGuiAttached: () => {
    //             props.eGridCell.style.borderColor = '';
    //             props.data.valid = true;

    //             setValue(props.value);
    //             if (refInput.current) {
    //                 refInput?.current.focus();
    //                 refInput?.current.select();
    //             }
    //         },            

    //         // Gets called once before editing starts, to give editor a chance to
    //         // cancel the editing before it even starts.
    //         isCancelBeforeStart() {
    //             return cancelBeforeStart;
    //         },

    //         // Gets called once when editing is finished (eg if enter is pressed).
    //         // If you return true, then the result of the edit will be ignored.
    //         isCancelAfterEnd() {
    //             return false;
    //         }
    //     };
    // });

    const isCancelBeforeStart = useCallback(() => {
        return cancelBeforeStart;
    }, [
        cancelBeforeStart
    ]);

    const isCancelAfterEnd = useCallback(() => {
        return false;
    }, []);

    useGridCellEditor({
        isCancelBeforeStart,
        isCancelAfterEnd
    });

    return (
        <InputMask
            ref={refInput}
            mask="__:__:__"
            showMask={true}
            replacement={{ _: /\d/ }}
            defaultValue={value}
            onChange={onChanged}
            onKeyDown={onKeyDown}
            style={{
                backgroundColor: theme.palette.background.paper,
                background: 'transparent',
                border: 'none',
                padding: '3px',
                outline: 'none',
            }}
        />
    );
};

